import Footer from "../../components/shared/Footer";
import "./TermsConditions.css";
import { useEffect } from "react";
import MobileTopBar from "../../components/mobile/MobileTopBar";
import LegalContent from "../../components/shared/LegalContent";
import { termsConditions } from "../../Data/siteContent";
import useResponsive from "../../hooks/useResponsive";

const TermsConditions = () => {
  const isMobile = useResponsive();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (isMobile) {
    return (
      <div>
        <MobileTopBar />
        <div className="terms-and-conditions-content">
          <LegalContent data={termsConditions} />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="t-c-div">
      <div className="terms-and-conditions-content">
        <LegalContent data={termsConditions} />
      </div>
    </div>
  );
};

export default TermsConditions;
